import React, { useEffect, useState } from 'react'
import { Card, CardBody, CardHeader, CardHeaderToolbar } from '../../../../_metronic/_partials/controls'
import Table, { dateFormatter, buttonsStyle } from '../../../components/tables/table'
import ConfirmDialog from '../../../components/dialogs/ConfirmDialog'
import { getFormsAdmin, deleteForm } from '../../../../api/form'
import { Button, Tooltip } from '@material-ui/core'
import DeleteIcon from '@material-ui/icons/Delete'
import EditIcon from '@material-ui/icons/Edit'
import { alertError, alertSuccess } from '../../../../utils/logger'
import { useHistory } from 'react-router-dom'

function getData(forms) {
  return forms.map((f) => ({
    id: f._id,
    title: f.title,
    url: f.googleFormsUrl,
    active: f.active ? 'Sí' : 'No',
    order: f.order,
    createdAt: f.createdAt,
  }))
}

export default function FormsPage() {
  const [data, setData] = useState([])
  const [formId, setFormId] = useState(null)
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false)
  const [refresh, setRefresh] = useState(false)
  const history = useHistory()

  function buttonFormatter(cell) {
    return (
      <>
        <Tooltip title="Edit">
          <Button style={buttonsStyle} size="small" onClick={() => history.push('/edit-form/' + cell)}>
            <EditIcon />
          </Button>
        </Tooltip>
        <Tooltip title="Delete">
          <Button
            style={buttonsStyle}
            size="small"
            onClick={() => {
              setFormId(cell)
              setOpenConfirmDialog(true)
            }}
          >
            <DeleteIcon />
          </Button>
        </Tooltip>
      </>
    )
  }

  const columns = [
    { dataField: 'title', text: 'Título', sort: true },
    { dataField: 'url', text: 'Google Forms', sort: true },
    { dataField: 'active', text: 'Activo', sort: true },
    { dataField: 'order', text: 'Orden', sort: true },
    { dataField: 'createdAt', text: 'Creado', formatter: dateFormatter, sort: true },
    { dataField: 'id', text: '', formatter: buttonFormatter },
  ]

  useEffect(() => {
    getFormsAdmin()
      .then((res) => {
        if (res.status === 200) {
          setData(res.data)
          setRefresh(false)
        }
      })
      .catch((error) => {
        alertError({ error, customMessage: 'No se pudieron cargar los formularios.' })
      })
  }, [refresh])

  return (
    <Card>
      <CardHeader title="Formularios (Participación ciudadana)">
        <CardHeaderToolbar>
          <button type="button" className="btn btn-primary" onClick={() => history.push('/edit-form')}>
            Añadir formulario
          </button>
        </CardHeaderToolbar>
      </CardHeader>
      <CardBody>
        <Table data={getData(data)} columns={columns} />
        <ConfirmDialog
          title="¿Eliminar este formulario?"
          open={openConfirmDialog}
          setOpen={setOpenConfirmDialog}
          onConfirm={() => {
            deleteForm(formId)
              .then((res) => {
                if (res.status === 200 || res.status === 204) {
                  alertSuccess({ title: 'Eliminado', customMessage: 'Formulario eliminado.' })
                  setRefresh(true)
                }
              })
              .catch((error) => {
                alertError({ error, customMessage: 'No se pudo eliminar.' })
              })
          }}
        />
      </CardBody>
    </Card>
  )
}
